var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/grid/node-grid.ts
import { css } from "@adornis/chemistry/directives/css.js";
import { html, nothing } from "lit";
import { customElement, state } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";
import { BuildifyLitElement } from "../../BuildifyLitElement.js";
var NodeGrid = class extends BuildifyLitElement {
  constructor() {
    super(...arguments);
    this._gridRef = createRef();
  }
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    console.log("calculate overflows");
    this._calculateOverflowVisuals();
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    this._calculateOverflowVisuals();
  }
  _calculateOverflowVisuals() {
    requestAnimationFrame(() => {
      const content = this._data.value;
      if (!content || !content.allowHorizontalOverflow)
        return;
      const container = this._gridRef.value;
      if (!container)
        return;
      const width = container.clientWidth;
      const scrollLeft = container.scrollLeft;
      const scrollWidth = container.scrollWidth;
      const hasOverflow = width !== scrollWidth;
      const atStart = scrollLeft === 0;
      const atEnd = scrollLeft + width >= scrollWidth - 1;
      if (!hasOverflow)
        return this._scrollInfo = void 0;
      if (this._scrollInfo?.showStart !== !atStart || this._scrollInfo.showEnd !== !atEnd) {
        this._scrollInfo = { showStart: !atStart, showEnd: !atEnd };
      }
    });
  }
  content({ content, mode }) {
    const columns = content?.columns ? content.columns : 3;
    const templateColumns = [];
    for (let i = 0; i < columns; i++) {
      const templateValue = content?.getColumnWidthByIndex(i) ?? "1fr";
      templateColumns.push(templateValue);
    }
    return html`
      <x-grid
        ${ref(this._gridRef)}
        @scroll=${(e) => {
      this._calculateOverflowVisuals();
    }}
        columns=${templateColumns.join(" ")}
        ${css({
      position: "relative",
      gridColumnGap: content?.gridColumnGap ?? "",
      gridRowGap: content?.gridRowGap ?? "",
      padding: content?.padding ?? "",
      background: content?.backgroundColor ?? "",
      overflowX: content?.allowHorizontalOverflow ? "auto" : "",
      height: "100%"
    })}
      >
        <slot data-horizontal-scroll=${String(!!content?.allowHorizontalOverflow)}></slot>
        ${mode === "edit" ? html`
              <x-flex
                ${css({ border: "1px lightgrey dashed", userSelect: "none", cursor: "pointer" })}
                center
                crossaxis-center
                @click=${(e) => {
      e.preventDefault();
      e.stopPropagation();
      this.append(document.createElement("node-grid-cell"));
    }}
              >
                Zelle hinzufügen
              </x-flex>
            ` : nothing}
      </x-grid>
      ${content?.allowHorizontalOverflow ? html`
            ${this._scrollInfo?.showStart ? html`
                  <x-flex
                    ${css({
      position: "absolute",
      left: "0",
      top: "0",
      bottom: "0",
      width: "40px",
      background: "linear-gradient(to right, rgba(175, 202, 0, 1) 40%, rgba(0, 0, 0, 0))",
      color: "#333",
      fontSize: "24px"
    })}
                    center
                    crossaxis-center
                  >
                    <x-icon ${css({ transform: "translateX(-8px)" })}> arrow_left </x-icon>
                  </x-flex>
                ` : nothing}
            ${this._scrollInfo?.showEnd ? html`
                  <x-flex
                    ${css({
      position: "absolute",
      right: "0",
      top: "0",
      bottom: "0",
      width: "40px",
      background: "linear-gradient(to left, rgba(175, 202, 0, 1) 40%, rgba(0, 0, 0, 0))",
      color: "#333",
      fontSize: "24px"
    })}
                    center
                    crossaxis-center
                  >
                    <x-icon ${css({ transform: "translateX(8px)" })}> arrow_right </x-icon>
                  </x-flex>
                ` : nothing}
          ` : nothing}
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          position: "relative",
          borderRadius: this._data.value?.borderRadius ?? "",
          height: this._data.value?.height ?? ""
        },
        "::slotted(*)": {
          boxSizing: "border-box"
        }
      }
    ];
  }
};
__decorateClass([
  state()
], NodeGrid.prototype, "_gridRef", 2);
__decorateClass([
  state()
], NodeGrid.prototype, "_scrollInfo", 2);
NodeGrid = __decorateClass([
  customElement("node-grid")
], NodeGrid);
export {
  NodeGrid
};
